const stripePublishableKey: any = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY;

export { stripePublishableKey };
